export default "https://cdn-static.gokick.com/assets/316c05c5b819a67ca00dcd3ca58b5d19adb19ecb/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";